/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiLoginIsTokenValidGet$Json } from '../fn/login/api-login-is-token-valid-get-json';
import { ApiLoginIsTokenValidGet$Json$Params } from '../fn/login/api-login-is-token-valid-get-json';
import { apiLoginIsTokenValidGet$Plain } from '../fn/login/api-login-is-token-valid-get-plain';
import { ApiLoginIsTokenValidGet$Plain$Params } from '../fn/login/api-login-is-token-valid-get-plain';
import { postLoginData$Json } from '../fn/login/post-login-data-json';
import { PostLoginData$Json$Params } from '../fn/login/post-login-data-json';
import { postLoginData$Plain } from '../fn/login/post-login-data-plain';
import { PostLoginData$Plain$Params } from '../fn/login/post-login-data-plain';
import { UserDto } from '../models/user-dto';

@Injectable({ providedIn: 'root' })
export class LoginService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postLoginData()` */
  static readonly PostLoginDataPath = '/api/Login';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postLoginData$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postLoginData$Plain$Response(params?: PostLoginData$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    return postLoginData$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postLoginData$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postLoginData$Plain(params?: PostLoginData$Plain$Params, context?: HttpContext): Observable<UserDto> {
    return this.postLoginData$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postLoginData$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postLoginData$Json$Response(params?: PostLoginData$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    return postLoginData$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postLoginData$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postLoginData$Json(params?: PostLoginData$Json$Params, context?: HttpContext): Observable<UserDto> {
    return this.postLoginData$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `apiLoginIsTokenValidGet()` */
  static readonly ApiLoginIsTokenValidGetPath = '/api/Login/isTokenValid';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLoginIsTokenValidGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLoginIsTokenValidGet$Plain$Response(params?: ApiLoginIsTokenValidGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return apiLoginIsTokenValidGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLoginIsTokenValidGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLoginIsTokenValidGet$Plain(params?: ApiLoginIsTokenValidGet$Plain$Params, context?: HttpContext): Observable<boolean> {
    return this.apiLoginIsTokenValidGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLoginIsTokenValidGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLoginIsTokenValidGet$Json$Response(params?: ApiLoginIsTokenValidGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return apiLoginIsTokenValidGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLoginIsTokenValidGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLoginIsTokenValidGet$Json(params?: ApiLoginIsTokenValidGet$Json$Params, context?: HttpContext): Observable<boolean> {
    return this.apiLoginIsTokenValidGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
